module.exports = __webpack_public_path__ + "img/11.6.CODm.8bbffd61.png";